const qS = require("query-string");

class TrackEvent {
    // TODO: Write code to verify url has utm parameters
    
    url = "/offers/ev";
    
    view = () =>{
    
        var data = {
            type: "view",            
            page: {
                name: window.location.href,
                title: document.title
            },
            utm: this.formatUTM(qS.parse(window.location.search))
        }

        fetch(this.url,{
            headers: {
                "Content-Type":"application/json; charset=utf-8"
            },
            method:"POST",
            body: JSON.stringify(data)
        })
    };

    event = (event) => {
        var data = {
            type: "event",
            event: event,
            utm: this.formatUTM(qS.parse(window.location.search))            
        }

        data.event["label"] = data.utm.campaign;

        fetch(this.url,{
            headers: {
                "Content-Type":"application/json; charset=utf-8"
            },
            method:"POST",
            body: JSON.stringify(data)
        })
    }

    formatUTM(utm){
        // Strips out utm_ part
        var newObj = {};
        for(var key in utm){
            newObj[key.replace("utm_","")] = utm[key];
        }
        return newObj
    }
}

export default new TrackEvent()


// WEBPACK FOOTER //
// ./src/event/index.js